import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/newhome/header/delivery_truck_bolt.svg")